import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Typography, StepLabel } from "@mui/material";
import axiosInstance from "../../../../router/interceptor";

import { Message, MessageSections } from "../../../components/message/message";
import BarekamButton, { ActionbarButtons } from "../../../components/button";
import BarekamInput from "../../../components/input/barekam-input";
import BarekamText from "../../../components/text";

import { Title } from "../Title/Title";

import {
  InnerContainer,
  SearchWrapper,
  StepLine,
  StepperWrapper,
  StepWrapper,
  Wrapper,
} from "./styled.components";
import { getMessage } from "../../../shared/helper-functions";
import { useAppSelector } from "../../../../redux/store";
import Container from "../Container";

const OrderTracking: React.FC = () => {
  const [trackingNumber, setTrackingNumber] = useState("");
  const [error, setError] = useState<string>("");
  const [activeStep, setActiveStep] = useState<number | null>();
  const [steps, setSteps] = useState<Record<string, string | number>[]>();
  const { messageCache, languageId } = useAppSelector(
    (state) => state.messagesReducer,
  );
  const { language } = useParams();

  const handleCheckStatus = async () => {
    try {
      if (trackingNumber) {
        const response =  await axiosInstance.get(
          `https://mw-crm.barekam.am/web/v3/action/trackNumber?track_number=${trackingNumber}`,
          {
            headers: {
              "Content-Type": "application/json",
              "accept-language": language || "en",
            },
          },
        );
        const resp = response.data;
        setError("");
        setSteps(resp?.data);
        setActiveStep(resp?.data[resp?.data.length - 1]?.status_id);
      }
    } catch (error) {
      setError("error");
      console.error("Error fetching order status:", error);
    }
  };

  return (
    <Wrapper id="track">
      <Title variant="h2" sx={{ marginBottom: "20px" }}>
        <Message
          messageKey={"track_your_order"}
          sectionId={MessageSections.MAIN}
        />
      </Title>
      <BarekamText variant={"m"} fontWeight={600} align={"center"}>
        <Message
          messageKey={"track_your_order_desc"}
          sectionId={MessageSections.MAIN}
        />
      </BarekamText>
      <Container>
        <InnerContainer>
          <SearchWrapper>
            <BarekamInput
              label="Tracking number"
              placeholder={getMessage("tracking_number", MessageSections.MAIN,
                messageCache, languageId
              )}
              value={trackingNumber}
              onChange={(e) => setTrackingNumber(e.target.value)}
              fullWidth
              width="600px"
              height="48px"
              customInputVariant="standard"
              error={!!error}
              errorMessage={
                error &&
                getMessage(
                  "tracking_number_error",
                  MessageSections.MAIN,
                  messageCache,
                  languageId,
                )
              }
            />
            <BarekamButton
              type={ActionbarButtons.NEW}
              size={"l"}
              onClick={handleCheckStatus}
            >
              <BarekamText variant={"m"} fontWeight={500} align={"center"}>
                <Message
                  messageKey={"track_order"}
                  sectionId={MessageSections.MAIN}
                />
              </BarekamText>
            </BarekamButton>
          </SearchWrapper>
          {activeStep && (
            <StepperWrapper
              activeStep={activeStep}
              alternativeLabel
              connector={<StepLine />}
            >
              {steps?.map((step: any, index: number) => (
                <StepWrapper key={index}>
                  <StepLabel>
                    {step?.name && (
                      <BarekamText variant={"m"} fontWeight={500} align={"center"}>
                        {step.name}
                      </BarekamText>
                    )}
                    {step.lastModifiedDate && (
                      <BarekamText variant={"m"} fontWeight={500} align={"center"}>
                        {step.lastModifiedDate}
                      </BarekamText>
                    )}
                  </StepLabel>
                </StepWrapper>
              ))}
              {steps?.[0].parcel_est_delivery_date && (
                <StepWrapper key={steps[0].parcel_est_delivery_date}>
                  <StepLabel>
                    <BarekamText variant={"m"} fontWeight={500} align={"center"}>
                      <Message
                        messageKey={"parcel_est_delivery_date"}
                        sectionId={MessageSections.MAIN}
                      />
                    </BarekamText>
                    <Typography variant="caption">
                      {steps[0].parcel_est_delivery_date}
                    </Typography>
                  </StepLabel>
                </StepWrapper>
              )}
            </StepperWrapper>
          )}
        </InnerContainer>
      </Container>
    </Wrapper>
  );
};

export default OrderTracking;
